import { Button, Stack, styled } from '@mui/material';

export const BottomSheetDialogButtonContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.75rem',
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
}));

export const BottomSheetDialogButton = styled(Button)({
  width: '100%',
});

export const BottomSheetDialogSecondaryButton = styled(Button)(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.neutral[300]}`,
}));
